// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__fsVqr","title":"style_title__nTtAX","subtitle":"style_subtitle__exp-C","containerTitle":"style_containerTitle__eqsa1","cancel":"style_cancel__LqlgT"};